// extracted by mini-css-extract-plugin
export default {"moniker":"_15gGlX5W"};